export default __webpack_public_path__ + "static/media/oval.10c8d82a.svg";